import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const codeListBulkDeleteModalThreshold = 5;

const BulkDeleteConfiguredCodesModal = ({ isOpen, onClose, onConfirm, rows, title }) => {
  if (!isOpen || !rows?.length) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container modal-animated">
        <div className="modal-header">
          <h2>{title}</h2>
          <button type="button" className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p>
            Remove {rows.length} selected code{rows.length !== 1 ? 's' : ''} from the configured list?
          </p>
          <div className="bulk-document-list">
            {rows.slice(0, codeListBulkDeleteModalThreshold).map((r) => (
              <div key={r.code} className="bulk-document-item">
                <div className="bulk-document-name">
                  ({r.code}) {r.preferredTerm}
                </div>
              </div>
            ))}
            {rows.length > codeListBulkDeleteModalThreshold && (
              <div className="bulk-document-more">
                …and {rows.length - codeListBulkDeleteModalThreshold} more
              </div>
            )}
          </div>
          <p className="retention-description" style={{ marginTop: '14px', color: '#666' }}>
            Save the generator configuration afterwards to persist changes.
          </p>
        </div>
        <div className="modal-actions">
          <button type="button" className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="admin-submit-button" style={{ backgroundColor: '#dc3545' }} onClick={onConfirm}>
            Remove from list
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkDeleteConfiguredCodesModal;
